import React, { Component } from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import DataGrid, { Editing, Scrolling, Export, HeaderFilter, SearchPanel, ColumnChooser, Form, Toolbar, Item as ToolbarItem } from 'devextreme-react/data-grid';
import * as activityCrud from '../../../../crud/activity.crud';
import * as activityScheduleCrud from '../../../../crud/activitySchedule.crud';
import * as contractDuck from '../../../../store/ducks/contract.duck';
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import { GetSecondaryDateTypes } from '../../../../shared/lookup';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { dxDateBoxProps } from '../../../../shared/config/DxFormProperties';
import ContractSecondaryDateDetails from './ContractSecondaryDateDetails';
import { Item } from 'devextreme-react/form';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import SystemHelper from "../../../../shared/systemHelper";

const manuallyEditableActionTypes = ['KeyDate', 'Sectional', 'AccessDate', 'OtherDate', 'CONTRACT_COMPLETION_DATE'];

class ContractSecondaryDates extends Component {

    constructor(props) {
        super(props);
        this.allowEdit = this.props.protectedRouteProps.allowEdit;
        this.contractDateTypes = GetSecondaryDateTypes(props.intl);
        this.newKeyAndCompletionDateFormConfig = {
            buttonResource: 'GENERAL.FORMS.BUTTON_ADD',
            fields: [
                {
                    resource: 'CONTRACT.SECONDARY.SUBTITLE',
                    fields: [
                        { resource: 'CONTRACT.SECONDARY.FIELD.NAME', dataField: 'name', },
                        { resource: 'CONTRACT.SECONDARY.FIELD.TYPE', dataField: 'type', editorType: 'dxSelectBox', editorOptions: { dataSource: this.contractDateTypes, valueExpr: 'value', displayExpr: 'display' } },
                        { resource: 'CONTRACT.SECONDARY.FIELD.DATE', dataField: 'actiondatedisplay', editorType: 'dxDateBox' },
                    ]
                }
            ]
        };
        this.state = {
            secondaryDates: null,
            seletedItemDetails: null
        }
    }
    componentDidMount() {
        this.fetchSecondaryDates();
    }
    fetchSecondaryDates = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: datesResp } = await activityScheduleCrud.getRegisterList(contractid);

            // const { data: datesResp } = await activityCrud.getContractSecondaryDates(companyid, projectid, contractid);
            this.setState({ secondaryDates: datesResp });
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }

    //editing row
    onRowUpdating = async (e) => {
        //Original price only changes if its not amended
        //same logic applied in API
        if (!e.oldData.lastamendingreference) {
            e.newData.originalactiondate = e.newData.actiondate;
        }

        e.cancel = this.updateSecondaryDatePromise(e.oldData, e.newData);
    }

    updateSecondaryDatePromise = (oldData, newData) => {
        return new Promise(async (resolve, reject) => {
            try {
                const newObject = { ...oldData, ...newData };
                if (oldData.actiontype === 'CONTRACT_COMPLETION_DATE') {
                    if (oldData.name != newObject.name) {
                        return reject("Contract Completion Date name cannot be changed.");
                    };
                    if (newObject.actiontype != 'CONTRACT_COMPLETION_DATE') {
                        return reject("Contract Completion Date type cannot be changed.");
                    };
                }
                else
                {
                    if (newObject.actiontype == 'CONTRACT_COMPLETION_DATE') {
                        return reject("Can not change to Contract Completion Date type.");
                    };
                }
                // data.originalprice = data.price;
                
                newObject.actiondatedisplay = moment(new Date(newObject.actiondate)).format("DD/MM/YYYY");
                await activityScheduleCrud.updateContractOtherDate(newObject);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    saveSecondaryDatePromise = (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                data.originalactiondate = data.actiondate;
                data.actiondatedisplay = moment(new Date(data.actiondate)).format("DD/MM/YYYY");
                await activityCrud.createActivity(data);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    //deleting row
    onRowRemoving = async (e) => {
        const { companyid, projectid, contractid } = this.props.contract;
        const deleteObj = { ...e.data, companyid, projectid, contractid };
        deleteObj.deleted = 1;
        e.cancel = this.deleteSecondaryDatePromise(deleteObj);
    }

    deleteSecondaryDatePromise = (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                data.actiondatedisplay = moment(new Date(data.actiondate)).format("DD/MM/YYYY");
                await activityCrud.createActivity(data);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }

    //adding row

    onRowInserting = async (e) => {
        const { companyid, projectid, contractid } = this.props.contract;
        const newSecondaryDate = { ...e.data, companyid, projectid, contractid };
        e.data.originalactiondate = e.data.actiondate;
        e.cancel = this.createSecondaryDatePromise(newSecondaryDate, e);
    }
    createSecondaryDatePromise = (date, e) => {
        return new Promise(async (resolve, reject) => {
            try {
                if(date.actiontype === 'CONTRACT_COMPLETION_DATE') {
                    throw new Error("Contract Completion Date cannot be added manually.");
                }
                date.actiondatedisplay = moment(date.actiondate).format('DD/MM/YYYY')
                date.createbyid = this.props.userProfile.accountid;
                const resp = await activityCrud.createActivity(date);
                e.data.activityscheduleid = resp.data;

                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        })
    }

    onInitNewRow = async (e) => {
        e.data = { deleted: 0 };
    }

    onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.MAIN_SHEET' }));

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
        }).then(() => {  // Using arrow function here
            workbook.xlsx.writeBuffer()
                .then((buffer) => {  // Using arrow function here to preserve 'this'
                    saveAs(
                        new Blob([buffer], { type: 'application/octet-stream' }),
                        this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.CONTRACT_SECONDARY_DATES' }) + '.xlsx'
                    );
                });
        });
    };


    allowDeleting = (e) => {
        if (e.row.data.actiontype === 'CONTRACT_COMPLETION_DATE') {
            return false;
        }
        return this.allowEdit && !e.row.data.lastamendingreference;
    }

    allowUpdating = (e) => {
        // if (e.row.data.type === 'CONTRACT_COMPLETION_DATE') {
        //     return false;
        // }
        return this.allowEdit && !e.row.data.lastamendingreference && manuallyEditableActionTypes.includes(e.row.data.actiontype);
    }
    viewChangeLogClick = async (e) => {
        const clonedItem = { ...e.row.data };
        this.setState({ seletedItemDetails: clonedItem })
    }
    regenerateContractDateChanges = async () => {
        let activateDialog = CustomDialog({
            title: "Delete & Regenerate Contract Date Changes",
            messageHtml: `<div style="max-width:60vw;">This process will delete all system generated contract date change history for this contract and regenerate contract date change for current state only. Are you sure you want to continue?</div>`,
            buttons: [
                {
                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                    onClick: (e) => { return "CANCEL" }
                },
                {
                    text: "Regenerate",
                    type: "danger",
                    stylingMode: "outlined",
                    onClick: (e) => { return "CONTINUE" }
                }
            ]
        });
        const result = await activateDialog.show();
        if (result === "CONTINUE") {
            this.setState({ isBusy: true }, async () => {
                try {
                    const { data: itemCount } = await activityScheduleCrud.regenerateContractDateChanges(this.props.contract.contractid)
                    this.props.enqueueSnackbar("System contract date change migration completed", { variant: "success" });
                    this.fetchSecondaryDates();
                    this.setState({ isBusy: false });
                } catch (err) {
                    this.setState({ isBusy: false });
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            })
        }


    }
    render() {
        if (!this.state.secondaryDates) {
            return (<PortletSpinner />);
        }

        return (
            <Portlet>
                <PortletBody>
                    <div style={{ width: '100%', height: '67vh' }}>
                        <DataGrid
                            dataSource={this.state.secondaryDates}
                            width='100%'
                            height='100%'
                            maxHeight='67vh'
                            allowColumnResizing={true}
                            hoverStateEnabled={true}
                            rowAlternationEnabled={false}
                            showBorders={true}
                            showColumnLines={true}
                            showRowLines={true}
                            remoteOperations={false}
                            allowColumnReordering={true}
                            columnResizingMode='widget'
                            onContextMenuPreparing={this.addGridContextMenuItems}
                            onRowUpdating={this.onRowUpdating}
                            onRowRemoving={this.onRowRemoving}
                            onInitNewRow={this.onInitNewRow}
                            onRowInserting={this.onRowInserting}
                            onExporting={this.onExporting}
                            // height={470}
                            style={{ maxHeight: '67vh' }}
                            name="contractSecondaryDates"
                            keyExpr="activityscheduleid"
                            loadPanel={{ showIndicator: !this.state.secondaryDates }}
                            columns={[
                                { caption: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.FIELD.NAME" }), dataField: "name" },
                                { caption: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.FIELD.TYPE" }), dataField: "actiontype", lookup: { dataSource: this.contractDateTypes, valueExpr: 'value', displayExpr: 'display' } },
                                { caption: "Original Date", dataField: "originalactiondate", dataType: "date", format: 'dd/MM/yyyy' },
                                { caption: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.FIELD.DATE" }), dataField: "actiondate", dataType: "date", format: 'dd/MM/yyyy' },
                                { caption: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.FIELD.LASTAMENDDATE" }), dataField: 'lastamenddate', dataType: "date", format: 'dd/MM/yyyy' },
                                { caption: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.FIELD.LASTAMENDREFERENCE" }), dataField: 'lastamendingreference' },
                                { caption: "Source Model", dataField: "sourcedmodel", visible: false },
                                { caption: "Source Record ID", dataField: "sourcedrecordid", visible: false },
                                {
                                    caption: "Edit",
                                    name: "editButtons",
                                    type: "buttons",
                                    buttons: [
                                        { name: "edit" },
                                        { name: "delete" },
                                    ]

                                },
                                {
                                    caption: "Logs",
                                    name: "viewLogsButton",
                                    type: "buttons",
                                    buttons: [
                                        { name: "ViewChangeLog", hint: "View Change Logs", icon: "bulletlist", onClick: this.viewChangeLogClick },
                                    ]

                                }
                            ]}
                        >
                            <Toolbar>
                                <ToolbarItem location="before">
                                    <div>
                                        <h3 style={{ fontFamily: SystemHelper.getThemeTextFont() ?? 'Poppins, Helvetica, sans-serif', fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                                            <FormattedMessage id='CONTRACT.SECONDARY.TITLE' />
                                        </h3>
                                    </div>
                                </ToolbarItem>
                                {
                                    (this.props.userProfile.accounttype === "System Owner" && !this.props.contract.ispackaged) && (
                                        <ToolbarItem
                                            location="after"
                                            locateInMenu="always"
                                            widget="dxButton"
                                            options={{
                                                icon: "deletetable",
                                                type: "danger",
                                                stylingMode: "outlined",
                                                text: "Regenerate Contract Date Changes",
                                                onClick: this.regenerateContractDateChanges,
                                            }}
                                        />
                                    )
                                }
                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    name="addRowButton"
                                    showText="always"
                                    options={{
                                        icon: "plus",
                                        text: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY_DATES.ADD_NEW" }),
                                    }}
                                />

                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    name="exportButton"
                                />
                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    name="applyFilterButton"
                                />
                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    name="columnChooserButton"
                                />
                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    name="searchPanel"
                                />
                            </Toolbar>
                            <Editing
                                mode="popup"
                                allowUpdating={this.allowUpdating}
                                allowDeleting={this.allowDeleting}
                                allowAdding={this.allowEdit}
                                confirmDelete={true}
                                popup={{ title: this.props.intl.formatMessage({ id: "CONTRACT.SECONDARY.TITLE" }), height: 380, width: 600, showTitle: true }}
                                useIcons={true}
                                form={{
                                    // customizeItem: (item) => {
                                    //     if (item.dataField === "actiontype" && item.editorType === "dxSelectBox") {
                                    //         item.editorOptions.readOnly = item.value === "CONTRACT_COMPLETION_DATE";
                                    //     }
                                    // },
                                    items: [
                                        { dataField: "name", colSpan: 2, validationRules: [{ type: "required" }] },
                                        { dataField: "actiontype", colSpan: 2, editorType: 'dxSelectBox', validationRules: [{ type: "required" }], editorOptions: { dataSource: this.contractDateTypes.filter(item => manuallyEditableActionTypes.includes(item.value)), valueExpr: 'value', displayExpr: 'display' } },
                                        { dataField: "actiondate", colSpan: 2, editorType: 'dxDateBox', validationRules: [{ type: "required" }], datatype: 'date', placeholder: 'DD/MM/YYYY', editorOptions: { ...dxDateBoxProps } },
                                    ]
                                }}
                            />
                            <Export enabled={true} fileName={this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.CONTRACT_SECONDARY_DATES' })} />
                            <ColumnChooser mode="select" enabled={true} />
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                            <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                        </DataGrid>
                    </div>
                    <ContractSecondaryDateDetails
                        secondaryDate={this.state.seletedItemDetails}
                        onClose={() => { this.setState({ seletedItemDetails: null }) }}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}





const mapStateToProps = store => ({
    lang: store.i18n.lang,
    contract: store.contract.contract,
    userProfile: store.auth.userProfile
});

const mapDispatchToProps = {
    loadContract: contractDuck.actions.fetchStart,
}

export default injectIntl(withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ContractSecondaryDates)));
